import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DatosEmpleadosService } from '../../../services/mantenimiento/datos-empleados.service';
import { EmpleadoCrud } from '../../../models/empleado';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { ColDef } from 'ag-grid-community';
import { GridColDefsEmpleados } from '../../../models/grid-col-defs-empleados';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { FiltroBasico, FiltroEmpleado } from 'src/app/shared/models/filtros';
import { EmpleadosModalComponent } from '../empleados-modal/empleados-modal.component';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { CentrosModel } from 'src/app/pages/configuracion/maestros/centros/models/centros-model';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { RecuperaEmpresasApiService } from 'src/app/pages/configuracion/maestros/empresas/services/recupera-empresas-api.service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { DatosCentrosService } from 'src/app/pages/configuracion/maestros/centros/services/datos-centros.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';
import { SqpGridComponentComponent } from 'src/app/shared/components/sqp-components/sqpGrid/sqp-grid-component/sqp-grid-component.component';
import { PaginationHelperService } from 'src/app/shared/services/pagination-helper.service';

@Component({
  selector: 'app-empleados-page',
  templateUrl: './empleados-page.component.html',
  styleUrls: ['./empleados-page.component.css']
})
export class EmpleadosPageComponent implements OnInit {

  empleados: EmpleadoCrud[]=[];
  columnDefs: ColDef[] = new GridColDefsEmpleados(this.datosEmpleadosService).columnDefs;
  empresas: EmpresasModel[];
  centros: CentrosModel[];
  textoBuscar: string = '';
  empresasLista: DesplegableData[];
  centrosLista: DesplegableData[];
  limpiarEstados: {num:number, clear: boolean};
  textoBorrar: string;
  empleadosSeleccionados: EmpleadoCrud[] = [];
  empresasListModal: string[] = [];
  filtrosEmpleados: FiltroEmpleado[] = [];
  filtrosEmpleadosAnteriores: FiltroEmpleado[] = [];
  currentPage = 1; // Current page number
  hasMoreRows = true; // Flag to check if more rows are available
  isLoading = false; // Prevent duplicate requests
  ordenColumna: OrdenColumna;
  gridOptions:any={
    suppressScrollOnNewData: true
  }
  @ViewChild(SqpGridComponentComponent) sqpGrid: SqpGridComponentComponent;
  lastFocusedRow: any;
  hasMoreRowsFiltroInput:boolean = true;
  dialogRefSpinner:any;
  gridSuppressSelectionEvents: boolean = false;

  constructor(private datosEmpleadosService: DatosEmpleadosService,
              private dialog: MatDialog,
              private exportadorPdfService: ExportadorPdfService,
              private exportadorExcelService: ExportadorExcelService,
              private router: Router,
              private cdRef: ChangeDetectorRef,
              private datosEmpresasApiService: RecuperaEmpresasApiService,
              private datosCentrosService: DatosCentrosService,
              private _snackBar: MatSnackBar,
              private paginationHelper: PaginationHelperService
              ) {}

  ngOnInit(): void {
    this.getCentros();
    this.getEmpresas();
    this.resetData('init');
  }

  //LLAMADAS A APIS PARA OBTENER LAS EMPRESAS, CENTROS Y EMPLEADOS
  getEmpresas(){
    this.datosEmpresasApiService.getEmpresas([],0).subscribe(
      next => {
        this.empresas = next;
        this.empresas.forEach(x=> this.empresasListModal.push(`${x.codigoEmpresa}-${x.nombreEmpresa.toUpperCase()}`))
        this.empresasLista = [...this.empresas].map(x=> { return { id: x.codigoEmpresa, desc: (x.nombreEmpresa == null) ? x.codigoEmpresa: `${x.codigoEmpresa} - ${x.nombreEmpresa}` }});
      },
      error => {
        console.error();
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  getCentros(){
    this.datosCentrosService.getCentros([],0).subscribe(
      next => {
        this.centros = next;
        this.centrosLista = [...this.centros].map(x=> { return { id: x.codigoCentro, desc: (x.nombreCentro == null) ? x.codigoCentro : `${x.codigoCentro} - ${x.nombreCentro}` }});
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  getEmpleados(origen: string, closeSpinner: boolean = true, pageSize:number = 100){
    this.isLoading = true;

    this.datosEmpleadosService.getEmpleados(this.filtrosEmpleados, this.currentPage, pageSize, this.ordenColumna)
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe({
      next: (response: any) => {
        this.empleados = [...this.empleados,...response];
        this.currentPage++;
        const returnedRowCount = response.length;
        if (returnedRowCount < pageSize) this.hasMoreRows = false;
        else this.hasMoreRows = true;

        this.isLoading = false;

        requestAnimationFrame(() => {
          // Only re-select if we're not in the middle of loading all rows
          if (closeSpinner) {
            this.selectPreviouslySelectedRows();
          }
          // Allow selection events again after re-select is applied
          this.gridSuppressSelectionEvents = false;
        });
        // Close spinner only after data is assigned and a paint tick (if closeSpinner is true)
        if (closeSpinner && this.dialogRefSpinner) {
          this.cdRef.detectChanges();
          requestAnimationFrame(() => {
            this.dialogRefSpinner?.close();
          });
        }
      },
      error: (error) => {
        console.error('Error loading rows:', error);
        if (closeSpinner) {
          this.dialogRefSpinner?.close();
        }
      }
    });
  }
//FIN LLAMADAS A APIS PARA OBTENER LAS EMPRESAS, CENTROS Y EMPLEADOS

//LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID
  resetData(origen: string){
    this.currentPage = 1;
    this.empleados = [];
    this.hasMoreRows = true;
    this.gridSuppressSelectionEvents = true;
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    this.getEmpleados(origen);
  }

  loadRows(){
    if(this.isLoading || !this.hasMoreRows) return; // Prevent duplicate requests
    else{
      this.gridSuppressSelectionEvents = true;
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
      this.getEmpleados('scroll', true, 100);
    }
  }

  loadRowsWithoutSpinner(){
    if(this.isLoading || !this.hasMoreRows) return;
    else{
      this.gridSuppressSelectionEvents = true;
      this.getEmpleados('scroll', false, 100); // Don't close spinner
    }
  }

  filtrarEmpleados(event: FiltroEmpleado[]){
    // Don't process filter changes if we're in the middle of a header selection action
    if (this.gridSuppressSelectionEvents) {
      return;
    }

    this.filtrosEmpleados = event;
    // Comparar con filtros anteriores y solo recargar si han cambiado
    const hasChanged = !this.datosEmpleadosService.areFiltroEmpleadoArraysEqual(this.filtrosEmpleados, this.filtrosEmpleadosAnteriores);
    if (hasChanged) {
      // Guardar copia inmutable de los filtros actuales
      this.filtrosEmpleadosAnteriores = JSON.parse(JSON.stringify(this.filtrosEmpleados));
      this.resetData('filtrar');
    }
  }

  buscarEmpleados(textoBuscar: string){
    if(this.empleados){
      this.textoBuscar = textoBuscar;
      this.cdRef.detectChanges(); //detectamos el cambio de la búsqueda aquí para que no nos salga el error "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked." al mostrar los empleados filtrados.
    }
  }

  ordenarGrid(event: OrdenColumna){
    this.ordenColumna = event;
    this.resetData('ordenar');
  }
//FIN LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID

//SELECCIONAR/DESELECCIONAR EMPLEADOS
  seleccionEmpleados(event: EmpleadoCrud[]){
    this.empleadosSeleccionados = event;
    if(this.empleadosSeleccionados.length > 1) this.textoBorrar = `${event.length} empleados seleccionados`;
    else this.textoBorrar = `${event.length} empleado seleccionado`;
  }

  deseleccionarAll(){
    this.sqpGrid.api.deselectAll();
  }

  selectPreviouslySelectedRows() {
    this.paginationHelper.selectPreviouslySelectedRows(
      this.sqpGrid.api,
      {
        selectedItems: this.empleadosSeleccionados,
        identifierField: 'codigo'
      }
    );
  }

  selectAllRowsInGrid() {
    this.sqpGrid.api.forEachNodeAfterFilter((node:any) => {
      node.setSelected(true);
    });
  }

  onHeaderSelectionToggled(allSelected: boolean){
    if (allSelected) {
      if(this.hasMoreRows){
        const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
          data: {
            tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
            titulo: 'Seleccionar todos los registros',
            mensaje: '<p>Para seleccionar todos los registros se tienen que descargar todos los datos, el proceso puede tardar más de lo habitual. ¿Desea continuar?</p>',
            textoConfirmacion: 'Seleccionar todos',
            textoCancelar: 'cancelar'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result === 'OK'){
            // Show spinner and load all remaining rows when "select all" is clicked
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            // Don't select rows yet, just load all data first
            this.loadAllRemainingRows();
          }
        });
      }else{ //no preguntamos ya que toda la data ya está cargada
        this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
        this.loadAllRemainingRows();
      }

    } else {
      // Update selection text and backup for deselect all
      this.empleadosSeleccionados = [];
    }
  }

  private loadAllRemainingRows() {
    // if (this.isLoading || !this.hasMoreRows) {
    if (!this.hasMoreRows) {

      // All rows loaded, now select all and paint them
      this.empleadosSeleccionados = [...this.empleados];
      this.textoBorrar = `${this.empleadosSeleccionados.length} empleados seleccionados`;

      // Select all rows in the grid and paint them blue
      this.cdRef.detectChanges();
      requestAnimationFrame(() => {
        this.selectAllRowsInGrid();
        // Close spinner after selection is complete
        if (this.dialogRefSpinner) {
          this.dialogRefSpinner.close();
        }
      });
      return;
    }

    // Load next batch of rows (without showing spinner since we already have one)
    this.loadRowsWithoutSpinner();

    // After loading, check if we need to load more
    setTimeout(() => {
      this.loadAllRemainingRows();
    }, 1000);
  }
//FIN SELECCIONAR/DESELECCIONAR EMPLEADOS

//ACCIONES EDITAR/ELIMINAR/CREAR NUEVO EMPLEADO/IMPORTAR

  abreModal(empleado: any){
    let info: any = {};
    info.empleado = empleado.data;
    info.nuevo = false;
    info.empresas = this.empresas;
    info.empresasList = this.empresasListModal;
    const dialogRef = this.dialog.open(EmpleadosModalComponent, {
      data: info,
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    // Store the row information and scroll position
    const editedRowId = empleado.data.codigo;
    const rowIndex = empleado.rowIndex;
    const initialCurrentPage = this.currentPage;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        // Reload data and maintain scroll position
        this.reloadDataAndMaintainScroll(editedRowId, rowIndex, initialCurrentPage);
      }
    });
  }

  private reloadDataAndMaintainScroll(editedRowId: string, originalRowIndex: number, targetPage: number) {
    // Store current scroll position
    const scrollTop = this.sqpGrid.api.getVerticalPixelRange()?.top || 0;

    // Clear and reload data
    this.empleados = [];
    this.currentPage = 1;
    this.hasMoreRows = true;
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);

    // Load data up to the target page to maintain the same data context
    this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
  }

  private loadDataUpToPage(targetPage: number, editedRowId: string, originalRowIndex: number, scrollTop: number) {
    if (this.isLoading || !this.hasMoreRows || this.currentPage > targetPage) {
      // All data loaded, now restore scroll
      this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      return;
    }

    this.isLoading = true;
    this.datosEmpleadosService.getEmpleados(this.filtrosEmpleados, this.currentPage, 100, this.ordenColumna).subscribe({
      next: (response: any) => {
        this.empleados = [...this.empleados,...response];
        this.currentPage++;
        const returnedRowCount = response.length;
        if (returnedRowCount < 100) {
          this.hasMoreRows = false;
        }else this.hasMoreRows = true;

        this.isLoading = false;

        // Continue loading if we haven't reached the target page and there are more rows
        if (this.currentPage <= targetPage && this.hasMoreRows) {
          this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
        } else {
          this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
        }
      },
      error: (error) => {
        console.error('Error loading rows:', error);
        this.isLoading = false;
        this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      }
    });
  }

  private restoreScrollAndSelectRow(editedRowId: string, originalRowIndex: number, scrollTop: number) {
    // Wait for the grid to render the data
    this.cdRef.detectChanges();
    requestAnimationFrame(() => {
      // Find the edited row and focus on the first editable cell
      this.sqpGrid.api.forEachNodeAfterFilter((node: any) => {
        if (node.data.codigo === editedRowId) {
          // Ensure the row is visible
          this.sqpGrid.api.ensureNodeVisible(node);

          // Focus on the first editable cell
          const columnToFocus = 'nombre';
          this.sqpGrid.api.setFocusedCell(node.rowIndex, columnToFocus);
        }
      });

      if (this.dialogRefSpinner) {
        this.dialogRefSpinner.close();
      }
    });
  }


  deleteEmpleado(){
    let textoEliminar = this.empleadosSeleccionados.length>1? `${this.empleadosSeleccionados.length} empleados`:`${this.empleadosSeleccionados.length} empleado`
    const dialogRefEliminar = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        tipo: TipoMensajeConfirmacion.ConfirmacionCompleja,
        icono: 'icon-delete',
        titulo: this.empleadosSeleccionados.length>1?'¿Eliminar empleados?':'¿Eliminar empleado?',
        textoConfirmacion: this.empleadosSeleccionados.length>1?'Eliminar los empleados seleccionados':'Eliminar el empleado seleccionado',
        textoBoton: 'Eliminar',
        iconoConfirmacion: 'icon-delete'
      }
    });
    dialogRefEliminar .afterClosed().subscribe(result => {
      if(result === 'OK'){
      const dialogRefSpinner = this.dialog.open(SpinnerModalComponent);
      let count: number = 0;
      this.empleadosSeleccionados.forEach(x=>{
        this.datosEmpleadosService.deleteEmpleado(x.codigo).subscribe(
          ok => {
            count++
            if(this.empleadosSeleccionados.length == count){
              dialogRefSpinner.close();
              const dialogRef = this.dialog.open(ModalMessageComponent, {
                data: {
                  mensaje: this.empleadosSeleccionados.length==1 ? 'Empleado eliminado correctamente':'Empleados eliminados correctamente',
                }
              });
              dialogRef.afterClosed().subscribe(() => {
                this.empleadosSeleccionados = [];
                this.resetData('eliminar');
              });
            }
          },
          error => {
            dialogRefSpinner.close();
            console.error("error", error);
            let textoError = this.empleadosSeleccionados.length>1? `${this.empleadosSeleccionados.length} empleados`:`${this.empleadosSeleccionados.length} empleado`
            const dialogRef = this.dialog.open(ModalMessageComponent, {
              data: {
                mensaje: this.empleadosSeleccionados.length==1 ? 'Error. El empleado no se ha eliminado':'Error. Los empleados no se han eliminado',
                alert: true
              }
            });
          }
        );
      })
      }
    })
  }

  creaNuevoEmpleado(){
    let info: any = {};
    info.empleado={} as EmpleadoCrud;
    info.nuevo = true;
    info.empresas = this.empresas;
    info.empresasList = this.empresasListModal;
    const dialogRef = this.dialog.open(EmpleadosModalComponent, {
      data: info,
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    dialogRef.afterClosed().subscribe(result=>{
      if(result === 'OK'){
        // this.textoBuscar = '';
        this.cdRef.detectChanges();
        this.resetData('nuevo')
      }
    })
  }

  goToImportEmpleados(){
    this.router.navigate(['/panel/empleados']);
  }

//FIN ACCIONES EDITAR/ELIMINAR/CREAR NUEVO EMPLEADO/IMPORTAR

//EXPORTAR PDF/EXCEL
  clickBarraSuperior(id: string){
    switch (id) {
      case 'Excel':
        this.exportaExcel();
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      default:
        break;
    }
  }

  exportaPdf(){
    if(this.empleados){
      let mensajePdf:string;
      if(this.hasMoreRows) mensajePdf = '<p>Genera un documento PDF con la información de los registros mostrados en el listado.</p><p>Para ello se tienen que descargar todos los datos, el proceso puede tardar más de lo habitual. ¿Desea continuar?</p>';
      else mensajePdf = '<p>Genera un documento PDF con la información de los registros mostradados en el listado</p>';
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: mensajePdf,
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        }
      });

      const datos = this.montarParametrosPdf();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosEmpleadosService.getEmpleados(this.filtrosEmpleados, 1, 0, this.ordenColumna).subscribe({
              next: (response: any) => {
                this.empleados=response;
                this.exportaPdfColumasModificadas(datos);
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            this.exportaPdfColumasModificadas(datos);
          }
        }
      });
    }
  }

  exportaPdfColumasModificadas(datos: DatosPdf){
    let empleadosExportar = [];
    empleadosExportar = [...this.empleados];
    empleadosExportar.map(x=>{
      x.nombreEmpresa = `${x.codigoEmpresa} - ${x.nombreEmpresa}`;
      x.nombreCentro = `${x.codigoCentro} - ${x.nombreCentro}`;
    })
    this.exportadorPdfService.exportaPdf(datos, empleadosExportar)
    //volvemos a dejar estos atributos como estaban al principio para que no se vayan duplicando cada vez que descargamos pdf o excel
    this.empleados.forEach(x=>{
      x.nombreEmpresa = x.nombreEmpresa.split(' - ')[1];
      x.nombreCentro = x.nombreCentro.split(' - ')[1];
    })
  }

  montarParametrosPdf(): DatosPdf{
    let columns: any [] = [];
    this.columnDefs.forEach( x => {
      columns.push( {header: x.headerName, dataKey: x.field} )
    })
    let fecha = new Date();
    let datosPdf = {
      landscape: true,
      nombreFichero:`Hire&Sign_empleados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  exportaExcel(){
    if(this.empleados){
      let mensajeExcel:string;
      if(this.hasMoreRows) mensajeExcel = '<p>Genera un documento Excel con la información de los registros mostrados en el listado.</p><p>Para ello se tienen que descargar todos los datos, el proceso puede tardar más de lo habitual. ¿Desea continuar?</p>';
      else mensajeExcel = '<p>Genera un documento Excel con la información de los registros mostradados en el listado</p>';
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: mensajeExcel,
          textoConfirmacion: 'Generar excel',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        }
      });


      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosEmpleadosService.getEmpleados(this.filtrosEmpleados, 1, 0, this.ordenColumna).subscribe({
              next: (response: any) => {
                this.empleados=response;
                let rows = this.GetRows(this.empleados);
                this.empleados.forEach(x=>{
                  x.nombreEmpresa = x.nombreEmpresa.split(' - ')[1];
                  x.nombreCentro = x.nombreCentro.split(' - ')[1];
                })
                let datosExcel = this.montarParametrosExcel();
                this.exportadorExcelService.exportaExcel(datosExcel, rows);
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            let datosExcel = this.montarParametrosExcel();
            let rows = this.GetRows(this.empleados);
            this.exportadorExcelService.exportaExcel(datosExcel, rows);
          }
        }
      });
    }
  }

  montarParametrosExcel(): DatosExcel{
    let fecha = new Date();
    let datosExcel = {
      workSheetName:'Empleados',
      nombreFichero:`Hire&Sign_empleados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumns()
    }
    return datosExcel
  }

  //Generamos las columnas basandonos en las del grid
  GetColumns(): any[]{
    let columns:any[] = [];
    this.columnDefs.forEach(x => {
      if(x.headerName!==''){
        let element:any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
      }

    });
    return columns;
  }

  // Mapeamos los datos de las empresas a las filas del excel
  GetRows(data:EmpleadoCrud[]):any[]{
    let rows:any[] = [];
    data.forEach(x=>{
      let row:any[] =
      [
        x.codigo,
        x.nombre,
        x.apellido1,
        x.apellido2,
        x.nif,
        x.nombreEmpresa = `${x.codigoEmpresa} - ${x.nombreEmpresa}`,
        x.nombreCentro = `${x.codigoCentro} - ${x.nombreCentro}`
      ];
      rows.push(row);
    });
    return rows
  }
//FIN EXPORTAR PDF/EXCEL

}
